<template>
    <div class="page">
        <public-head title="高职社招"></public-head>
        <div class="background">
            <div class="search">
                <!-- <form bindsubmit="formSubmit"> -->
                <input
                    class="s_text"
                    id="name"
                    name="name"
                    placeholder="请输入高校名称"
                    placeholder-class="placeholder"
                    v-model="value"
                />
                <img
                    src="https://new.schoolpi.net/attach/small_program/class/search.png"
                    alt
                    class="font_family icon-sousuo s_btn"
                    @click="search"
                />
                <!-- <button class='font_family icon-sousuo s_btn' formType="submit"></button> -->
                <!-- </form> -->
            </div>
        </div>
        <div>
            <!-- 轮播部分 -->
            <van-swipe :autoplay="3000" style="height: 180px;">
                <div v-for="(item,index) in bannerList" :key="index">
                    <van-swipe-item>
                        <img :src="item.ad_code" class="slide-image" @click="openAdLink(item)" />
                    </van-swipe-item>
                </div>
            </van-swipe>
        </div>
        <!-- 头条部分 -->
        <div class="toutiao">
            <!-- <icon ></icon> -->
            <img
                src="https://new.schoolpi.net/attach/small_program/index/cate_one.jpg"
                alt
                class="font_family icon-TOUXIAO toutiao-icon"
            />
            <div class="ttlist">
                <van-swipe :autoplay="3000" vertical class="swiper" :show-indicators="false">
                    <div v-for="(item,index) in topnewslist" :key="index">
                        <van-swipe-item>
                            <div class="text" @click="goHeadDetail(item)">
                                <!-- <div class="line"></div> -->
                                <div>{{item.title}}</div>
                            </div>
                        </van-swipe-item>
                    </div>
                </van-swipe>
            </div>
        </div>
        <!-- 导航 -->
        <div class="nav">
            <div class="nav-item">
                <div
                    v-for="(item,index) in menuList"
                    :key="index"
                    :class="[currentTab==index?'nav-active':'']"
                    @click="selectMenu(index)"
                >{{item}}</div>
            </div>
        </div>
        <!--********************学校列表********************-->
        <van-list
            v-if="currentTab ===0"
            class="scroller"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div class="school scroll-list">
                <div
                    class="school-item"
                    v-for="(item,index) in schoolList"
                    :key="index"
                    @click="goSchoolDetail(item)"
                >
                    <!-- <navigator url="../school/school?id={{item.id}}"> -->
                    <div class="school-img">
                        <img :src="item.thumb" />
                    </div>
                    <div class="school-name">{{item.name}}</div>

                    <!-- </navigator> -->
                </div>
            </div>
        </van-list>
        <!--********************政策课堂********************-->
        <div v-if="currentTab ===1 ">
            <div class="classroom" @click="showClass(1)">
                <div class="sign"></div>
                <div class="class-title">报名对象</div>
                <div class="icon-class">
                    <div v-if="!showInfo1" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo1" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>
            <div class="class-detail" v-if="showInfo1">
                <p v-html="policyinfo.enrolment_object"></p>
            </div>
            <div class="classroom" @click="showClass(9)">
                <div class="sign"></div>
                <div class="class-title">报名条件</div>
                <div class="icon-class">
                    <div v-if="!showInfo9" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo9" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo9">
                <p v-html="policyinfo.entry_requirements"></p>
            </div>

            <div class="classroom" @click="showClass(2)">
                <div class="sign"></div>
                <div class="class-title">报名时间</div>
                <div class="icon-class">
                    <div v-if="!showInfo2" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo2" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo2">
                <p v-html="policyinfo.registration_time"></p>
            </div>

            <div class="classroom" @click="showClass(3)">
                <div class="sign"></div>
                <div class="class-title">报名流程</div>
                <div class="icon-class">
                    <text v-if="!showInfo3" class="font_family icon-youhua jiantou"></text>
                    <text v-if="showInfo3" class="font_family icon-xiahua jiantou"></text>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo3">
                <p v-html="policyinfo.registration_process"></p>
            </div>

            <div class="classroom" @click="showClass(4)">
                <div class="sign"></div>
                <div class="class-title">考试内容</div>
                <div class="icon-class">
                    <div v-if="!showInfo4" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo4" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo4">
                <p v-html="policyinfo.enrollment_institutions"></p>
            </div>

            <div class="classroom" @click="showClass(5)">
                <div class="sign"></div>
                <div class="class-title">学费标准</div>
                <div class="icon-class">
                    <div v-if="!showInfo5" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo5" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo5">
                <p v-html="policyinfo.tuition_standard"></p>
            </div>

            <div class="classroom" @click="showClass(6)">
                <div class="sign"></div>
                <div class="class-title">授课模式</div>
                <div class="icon-class">
                    <text v-if="!showInfo6" class="font_family icon-youhua jiantou"></text>
                    <text v-if="showInfo6" class="font_family icon-xiahua jiantou"></text>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo6">
                <p v-html="policyinfo.teaching_mode"></p>
            </div>

            <div class="classroom" @click="showClass(7)">
                <div class="sign"></div>
                <div class="class-title">毕业证书</div>
                <div class="icon-class">
                    <text v-if="!showInfo7" class="font_family icon-youhua jiantou"></text>
                    <text v-if="showInfo7" class="font_family icon-xiahua jiantou"></text>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo7">
                <p v-html="policyinfo.graduation_certificate"></p>
            </div>

            <div class="classroom" @click="showClass(8)">
                <div class="sign"></div>
                <div class="class-title">政策减免</div>
                <div class="icon-class">
                    <div v-if="!showInfo8" class="font_family icon-youhua jiantou"></div>
                    <div v-if="showInfo8" class="font_family icon-xiahua jiantou"></div>
                </div>
            </div>

            <div class="class-detail" v-if="showInfo8">
                <p v-html="policyinfo.policy_reduction"></p>
            </div>
        </div>

        <!--********************热门专业********************-->
        <van-list v-if="currentTab ===2 " class="major"  :finished="finished"
            finished-text="没有更多了"
            @load="onLoad1">
            <div class="major-item" v-for="(item,index) in majorList" :key="index">
                <div class="major-title">
                    <div class="ico"></div>
                    <div class="apply-title">{{item.career_name}}</div>
                </div>
                <div class="major-detail">{{item.professional_introduction}}</div>
                <div class="cross-line"></div>
                <div class="major-info">
                    <div class="major-years">
                        <div class="data">{{item.study_years}}</div>
                        <div>修学年限</div>
                    </div>
                    <div class="line"></div>
                    <div class="major-salary">
                        <div class="data">{{item.ranking}}</div>
                        <div>热门排名</div>
                    </div>
                    <div class="line"></div>
                    <div class="major-top">
                        <div class="data">
                             <!-- class="font_family icon-shoucangshixin xingxinged"
                                v-for="(item,index) in item.star"
                                :key="index" -->
                            <div>*****</div>
                        </div>
                       
                        <div>推荐指数</div>
                    </div>
                </div>
                <div class="favorite"></div>
            </div>
        </van-list>
        <!--********************报名信息********************-->
        <div v-if="currentTab ===3 ">
            <div v-for="(item,index) in applyList" :key="index">
                <div class="apply" @click="showMore(index)">
                   
                    <div class="apply-title"> <div class="circle"></div>{{item.city_name}}地区报名点</div>
                    <div class="icon">
                        <text v-if="!item.isOpen" class="font_family icon-youhua jiantou"></text>
                        <text v-if="item.isOpen" class="font_family icon-xiahua jiantou"></text>
                    </div>
                      <van-icon name="arrow" v-if="show"/>
                     <van-icon name="arrow-down" v-if="isshow&&index==xiabiao"/>
                   
                </div>

                <div v-if="item.isOpen">
                    <div class="apply-detail" v-for="(item,index) in item.child" :key="index">
                        <div>县(区):{{item.district}}</div>
                        <div>报名点:{{item.entry_point}}</div>
                        <div>报名点地址:{{item.address}}</div>
                        <div>
                            报名电话:{{item.telephone}}
                        <a class="_list" href="tel:0553-5971066">一键拨号</a>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost } from "../../../axios/index";
import PublicHead from "../../../components/publicHead";
import BScroll from "better-scroll";

export default {
    data() {
        return {
            value: "", //搜索框输入的值
            currentTab: 0,
            indicatorDots: true,
            autoplay: true,
            interval: 5000,
            duration: 3000,
            bannerList: [],
            policyinfo: {},
            showInfo1: false,
            showInfo2: false,
            showInfo3: false,
            showInfo4: false,
            showInfo5: false,
            showInfo6: false,
            showInfo7: false,
            showInfo8: false,
            showInfo9: false,
            menuList: ["学校列表", "政策课堂", "热门专业", "报名信息"],
            applyList: [],
            topnewslist: [],
            schoolList: [],
            majorList: [],
            page: 1,
            loading: false,
            finished: false,
            offset: 100,
            xiabiao:0,
            show:true,
            isshow:false
        };
    },
    created() {},
    methods: {
        onLoad() {
            this.page = this.page + 1;
            if (!this.finished) {
                httpPost("/vocational/index_school", {
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
                }).then(res => {
                    if (res.code === 1) {
                        this.schoolList = [...this.schoolList, ...res.list];
                    } 
                      
                });
            }
        },
        onLoad1() {
            this.page = this.page + 1;
            if (!this.finished) {
                httpPost("/vocational/index_school", {
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
                }).then(res => {
                    if (res.code === 1) {
                        this.majorList = [...this.majorList, ...res.list];
                    } 
                      
                });
            }
        },
        // 点击搜索
        search() {
            var name = this.value;
           
            httpPost("/vocational/index_school", {
                province:this.$store.state.areaInfo.pid,
                school_name: name,
                page:1,
                num:12
            }).then(res => {
               
                if (res.code === 1) {
                    this.schoolList = res.list;
                }else{
                    this.$toast.fail("请输入正确的学校全称")
                }
            });
        },
       
        // 点击头条
        goHeadDetail(e) {
         
            this.$router.push({
                path: "/index/indexNews",
                query: {
                    id: e.id
                }
            });
        },
        // 点击导航部分切换内容
        selectMenu(e) {
            if (e === 2) {
                httpPost("/vocational/index_career", {
                    page: 1
                }).then(res => {
                    if (res.code === 1) {
                       
                        var majorList = res.list;
                        for (var i = 0; i < majorList.length; i++) {
                            majorList[i].star = [];
                            majorList[i].star.length = majorList[i].recommend;
                        }
                        this.majorList = res.list;
                    }
                });
            }
            if (e === 3) {
                httpPost("/vocational/index_enroll", {
                    page: 1,
                    province: this.$store.state.areaInfo.pid
                }).then(res => {
                    if (res.code === 1) {
                        var applyList = res.list;
                        for (var i = 0; i < applyList.length; i++) {
                            applyList[i].isOpen = false;
                        }
                        this.applyList = applyList;
                    }
                });
            }
            (this.currentTab = e), (this.page = 2);
        },
        //点击课堂政策显示对应的内容
        showClass(e) {
           
            if (e == 1) {
                this.showInfo1 = !this.showInfo1;
            }
            if (e == 2) {
                this.showInfo2 = !this.showInfo2;
            }
            if (e == 3) {
                this.showInfo3 = !this.showInfo3;
            }
            if (e == 4) {
                this.showInfo4 = !this.showInfo4;
            }
            if (e == 5) {
                this.showInfo5 = !this.showInfo5;
            }
            if (e == 6) {
                this.showInfo6 = !this.showInfo6;
            }
            if (e == 7) {
                this.showInfo7 = !this.showInfo7;
            }
            if (e == 8) {
                this.showInfo8 = !this.showInfo8;
            }
            if (e == 9) {
                this.showInfo9 = !this.showInfo9;
            }
        },
        // 点击报名信息详情
        showMore(i) {
            // 获取下标
            this.applyList.map((item,index)=>{
                if(i==index){
                    this.show=!this.show,
                     this.isshow=!this.isshow 
                }
            })
            var index = i;
            this.xiabiao=index;
            var applyList = this.applyList;
            applyList[index].isOpen = !applyList[index].isOpen;
            this.applyList = applyList;
        },
        //进去学校详情
        goSchoolDetail(e) {
            this.$router.push({
                path: "/shezhao/detail",
                query: {
                    sid: e.id
                }
            });
        },

        fetchList() {
            // 获取banner
            httpPost("/ad/rotation_vocational", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
               
                if (res.code === 1) {
                    this.bannerList = res.banlist;
                }
            });
            // 获取头条数据
            httpPost("/vocational/index", {
                province: this.$store.state.areaInfo.pid,
                uid: this.$store.state.userInfo
            }).then(res => {
               
                if (res.code === 1) {
                    this.topnewslist = res.topnewslist;
                }
            });
            // 获取学校列表数据
            httpPost("/vocational/index_school", {
                province: this.$store.state.areaInfo.pid,
                page: 1
            }).then(res => {
               
                if (res.code === 1) {
                    this.schoolList = res.list;
                    this.page++;
                }
            });
            // 获取政策课堂下面的每一个详细数据
            httpPost("/vocational/index_policy", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
               
                if (res.code === 1) {
                    this.policyinfo = res.data;
                }
            });
        }
    },
    mounted() {
        this.fetchList();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.apply-detail a{
    width: 64px !important;
    height: 18px !important;
    background: #22d9d9 !important;
    color: #fff !important;
}

.swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.van-swipe-item{
    display: flex !important;
}
.swiper_container{
        width: 100%;
        height: 100%;
        overflow: hidden;
}
.font_family {
    width: 20px;
}
.van-swipe__indicator--active {
    background: 0 !important;
}
.page {
    background: #f2f2f2;
}

van-swipe {
    height: 12.5rem;
    width: 100%;
}

van-swipe img {
    width: 100%;
    height: 12.5rem;
}

.slide-image {
    height: 12.5rem;
    width: 100%;
}

.background {
    background: #22d9d9;
    padding: 0.3125rem 0 0.625rem;
    margin-top: 46px;
}

.search {
    width: 90vw;
    margin: 0 5vw;
    height: 2.0625rem;
    border: #fff 0.0625rem solid;
    border-radius: 1.75rem;
    line-height: 2.0625rem;
    position: relative;
}

.s_text {
    float: left;
    text-align: left;
    color: #fff;
    padding: 0 0.8125rem;
    width: 80%;
    height: 100%;
    border: none;
    font-size: 1rem;
    background: #22d9d9;
    border-radius: 20px;
}
input::-webkit-input-placeholder {
    color: #ffffff;
    line-height: 2rem;
}
.s_btn {
    position: absolute;
    width:2.125rem;
    height: 1.6rem;
    border: none;
    color: #fff;
    font-size: 1rem;
    line-height: 1.2;
    /* color: #fff; */
    text-align: right;
    right: 0;
    top: 4px;
    background: none;
    padding-right: 0.625rem;
}

/*头条*/

.toutiao {
    height: 2.8125rem;
    overflow: hidden;
    border-left: #f0f0f0 0.0625rem solid;
    border-right: #f0f0f0 0.0625rem solid;
    border-bottom: #f8f9fa 0.0625rem solid;
    border-top: #e7ecef 1rpx solid;
    box-shadow: 0 0.0625rem 0 #f8f9fa;
    display: flex;
    position: relative;
}

.toutiao-icon {
    font-size: 4.375rem;
    float: left;
    color: #22d9d9;
    line-height: 90rpx;
    width: 4.375rem;
}

.toutiao img {
    width: 3.4375rem;
    height: 2rem;
    float: left;
    margin: 0.5rem 0.625rem 0 0.625rem;
    width: 30px;
    border-radius: 15px;
}

.ttlist {
    float: left;
    width: 72%;
    height: 2.8125rem;
    flex-grow: 1;
}

.toutiao .text {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
}

.toutiao text {
    height: 1.4375rem;
    width: 95%;
    overflow: hidden;
    font-size: 0.9375rem;
    display: flex;
    display: -webkit-flex;
    margin-top: 0.375rem;
}

.toutiao .line {
    width: 0.3125rem;
    height: 0.3125rem;
    background: #726f6f;
    border-radius: 50%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
}

/*导航菜单模块*/

.nav {
    position: relative;
    font-family: PingFang-SC-Regular;
    font-size: 0.875rem;
    color: #808080;
    width: 90vw;
    margin: 0 5vw;
    margin-top: 0px;
    height: 7vw;
    border-radius: 0.3125rem;
    padding-top: 0.3125rem;
}

.nav-item {
    display: flex;
    justify-content: space-around;
    position: absolute;
    text-align: center;
    width: 90vw;
}

.nav-active {
    color: #383838;
    font-weight: 600;
}

/* 政策课堂 */

.classroom {
    width: 100vw;
    /* height: 100rpx; */
    background: #fff;
    margin-top: 0.625rem;
    display: flex;
    color: #383838;
    position: relative;
    align-items: center;
}

.sign {
    width: 0.3125rem;
    height: 2.1875rem;
    margin-left: 0.625rem;
    background: #22d9d9;
}

.class-title {
    font-weight: 600;
    font-size: 1.0625rem;
    line-height: 3.125rem;
    margin-left: 0.625rem;
}

.class-detail {
    line-height: 0.9375rem;
    background: #f2f2f2;
    color: #9b9b9b;
    font-size: 0.875rem;
    padding-left: 0.8125rem;
    padding-top: 0.625rem;
}

.icon {
    position: absolute;
    top: 0;
    right: 0.625rem;
}

.icon-class {
    font-size: 1.875rem;
    position: absolute;
    top: 0;
    right: 0.625rem;
}

/* 学校列表 */

.school {
    display: flex;
    flex-wrap: wrap;
    width: 100vw;
    margin-bottom: 1.25rem;
}

.school-item {
    width: 30vw;
    margin-left: 2.5vw;
    margin-top: 1.25rem;
}

.school-img {
    width: 28vw;
    margin: 0 auto;
    height: 8.4375rem;
    border-radius: 0.125rem;
    box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.2);
}

.school img {
    width: 100%;
    height: 100%;
    border-radius: 0.0625rem;
}

.school-info {
    margin-top: 0.625rem;
    display: flex;
}

.school-logo {
    width: 1.5625rem;
    height: 1.5625rem;
    border-radius: 1.5625rem;
    margin-top: 0.375rem;
    margin-left: 0.3125rem;
    overflow: hidden;
}

.school-name {
    font-size: 0.75rem;
    padding-top: 0.625rem;
    overflow: hidden;
    height: 1.9375rem;
    text-align: center;
}

/*热门专业模块*/

.major {
    margin-top: 1.5625rem;
    /* width: 90vw;
    margin: 45rpx 5vw; */
}

.major-item {
    font-family: PingFang-SC-Regular;
    background: #fff;
    margin-bottom: 1.25rem;
}

.major-title {
    display: flex;
    padding: 0.625rem 0;
    align-items: center;
}

.ico {
    width: 0.25rem;
    height: 0.9375rem;
    background: #22d9d9;
    margin-top: 0.1875rem;
    margin-left: 0.625rem;
}

.apply-title {
    margin-left: 0.625rem;
    font-size: 1rem;
    font-weight: 600;
    color: #383838;
    display: flex;
}
.van-icon{
    font-size: 20px;
    line-height: 40px;
}
.major-detail {
    font-size: 0.875rem;
    font-family: PingFang-SC-Regular;
    color: #5b5b5b;
    line-height: 1.5;
    padding: 0 0.1875rem 0 0.1875rem;
    padding-bottom: 1.25rem;
    text-align: center;
}

.major-info {
    display: flex;
    justify-content: space-around;
}

.major-years,
.major-salary,
.major-top {
    width: 30vw;
    margin: 0.9375rem 0;
    text-align: center;
    font-size: 0.75rem;
    font-family: PingFang-SC-Regular;
}

.data {
    padding-bottom: 0.625rem;
}

.cross-line {
    width: 100%;
    margin: 0 auto;
    height: 0.0625rem;
    background: #e2eaed;
}

.line {
    width: 0.0625rem;
    height: 1.25rem;
    background: #e2eaed;
    /* margin-top: 1.625rem; */
    margin-right: 0.3125rem;
}

/* 报名信息 */

.apply {
    line-height: 2.5rem;
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-bottom: 0.0625rem #f2f2f2 solid;
    position: relative;
    padding-right:20px;
}

.circle {
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 0.625rem;
    margin-left: 0.625rem;
    margin-top: 0.9375rem;
    background: #22d9d9;
    margin-right: 10px;
}

.apply-title {
    margin-left: 0.625rem;
    font-size: 0.9375rem;
}

.apply-detail {
    font-size: 1rem;
    color: #989898;
    line-height: 1.4375rem;
    padding: 0.625rem;
}
.calling {
    background: #22d9d9;
    color: #fff;
    padding: 0.1875rem 0.3125rem;
    border-radius: 0.1875rem;
    font-size: 0.75rem;
    margin-left: 0.625rem;
}
</style>

